import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { PaymentLinkLandingComponentActions } from './store';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'payment-link-landing-container',
  templateUrl: './payment-link-landing-container.component.html',
  styleUrls: ['./payment-link-landing-container.component.scss'],
})
export class PaymentLinkLandingContainerComponent implements OnInit {
  constructor(
    private store: Store,
    private route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    const paymentLinkToken =
      this.route.snapshot.paramMap.get('paymentLinkToken');

    this.store.dispatch(
      PaymentLinkLandingComponentActions.initialize({
        paymentLinkToken,
      }),
    );
  }
}
